import { Button, Typography } from '@breetometer/components';
import { ChevronDown } from 'BreetAssets';
import { type RefObject, useCallback } from 'react';

import { DropdownWrapper } from '../Dropdown';
import type { ISelectInput, ISelectInputOption } from './SelectInput.helpers';

const SelectInput = ({ label, defaultOption, options, onChange, value }: ISelectInput) => {
	const selectValue = options?.find((i) => i.value && i.value === (value ?? defaultOption.value))?.label ?? defaultOption.label;

	const selectDropdownItem = useCallback(
		(item: ISelectInputOption, handleVisibility: () => void) => () => {
			onChange?.(item);
			handleVisibility();
		},
		[onChange]
	);

	return (
		<div className='selectinput'>
			<DropdownWrapper>
				{({ buttonRef, controlRef, dropdownRef, dropdownStyles, handleVisibility, visible }) => (
					<div
						className='selectinput_buttonwrapper'
						ref={controlRef as RefObject<HTMLDivElement>}
					>
						<div className='selectinput_control'>
							{!!label && <label>{label}</label>}

							<Button
								variant='native'
								ref={buttonRef}
								onClick={handleVisibility}
							>
								{selectValue}
								<ChevronDown />
							</Button>
						</div>
						{visible && (
							<div
								className='ul-container dropdownshadow'
								ref={dropdownRef}
								style={dropdownStyles}
							>
								<Typography
									as='ul'
									className='scrollbar'
								>
									{options?.map((optionItem) => (
										<Typography
											as='li'
											key={optionItem.label}
										>
											<Button
												variant='native'
												onClick={selectDropdownItem(optionItem, handleVisibility)}
											>
												{optionItem.icon} {optionItem.label}
											</Button>
										</Typography>
									))}
								</Typography>
							</div>
						)}
					</div>
				)}
			</DropdownWrapper>
		</div>
	);
};

export default SelectInput;
